import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FormattedMessage } from 'LearningCenterUI/components/I18n'; //@ts-expect-error Could not find declaration file for module

import ResponsiveCardGridContainer from '../ResponsiveCardGridContainer';
import LessonCardContainer from '../LessonCard/LessonCardContainer';
import TrackCardContainer from '../../containers/TracksPage/TrackCardContainer';
import styled from 'styled-components';
import UsageTracker from '../../utils/UsageTracker';
import { device } from '../../constants/StyledComponentConstants';
import UIBox from 'UIComponents/layout/UIBox';
import { isLessonRecommendation } from '../../features/recommendations/recommendationsUtils';
import SectionHeading from '../SectionHeading';
import UIFlex from 'UIComponents/layout/UIFlex';
const RecommendationsSectionWrapper = styled.div.withConfig({
  displayName: "RecommendationsSection__RecommendationsSectionWrapper",
  componentId: "bztzvb-0"
})(["margin-top:35px;@media screen and ", "{margin-top:20px;}"], device.mobile);

const RecommendationsSection = ({
  cardFooters,
  recommendations,
  title,
  titleAction,
  subTitle,
  testId,
  source
}) => {
  const trackRecommendedCardClick = useCallback((recommendation, index) => () => {
    const {
      recommendationType,
      recommendationId,
      recommendationStrategy
    } = recommendation;
    const {
      entityId,
      entityType
    } = recommendation.recommendationMetadata;
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-card-click',
      cardNumber: index + 1,
      lessonId: isLessonRecommendation(recommendationType) && recommendationId,
      trackId: recommendationType === 'TRACK' && recommendationId,
      recommendationStrategy,
      recommendedBecauseTrackId: entityType && entityType === 'TRACK' && entityId,
      recommendedBecauseLessonId: entityType && isLessonRecommendation(entityType) && entityId
    });
  }, []);
  return /*#__PURE__*/_jsxs(RecommendationsSectionWrapper, {
    "data-test-id": testId,
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        subText: subTitle,
        children: title || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.headers.recommended"
        })
      }), titleAction && /*#__PURE__*/_jsx(UIBox, {
        children: titleAction
      })]
    }), /*#__PURE__*/_jsx(ResponsiveCardGridContainer, {
      columnSize: 250,
      columns: 3,
      maxCardWidth: 405,
      nowrap: true,
      children: recommendations.map((recommendation, index) => {
        const {
          recommendationId,
          recommendationType
        } = recommendation;
        const cardProps = {
          appearsIn: source,
          footer: cardFooters && cardFooters[index],
          isFlushOnMobile: false,
          key: recommendationId,
          onClick: trackRecommendedCardClick(recommendation, index),
          position: index + 1
        };
        return isLessonRecommendation(recommendationType) ? /*#__PURE__*/_jsx(LessonCardContainer, Object.assign({}, cardProps, {
          lessonId: recommendationId
        })) : /*#__PURE__*/_jsx(TrackCardContainer, Object.assign({}, cardProps, {
          isUnfilterable: true,
          trackId: recommendationId
        }));
      })
    })]
  });
};

export default RecommendationsSection;